import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

const field = (key: string) => `${sel("preferenceField")}[data-pref="${key}"]`;

/**
 * Academy lesson: preferences in depth. Started from the lesson page in a new
 * tab; never auto-started. Nothing is saved unless the officer clicks Save
 * Preferences themselves.
 */
const tour: TutorialDefinition = {
  id: "report-preferences-in-depth",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Preferences in depth",
  description: "See what each group of Report Preferences changes in the draft, and add your Common Spellings.",
  triggerRoute: /^\/preferences$/,
  startRoute: "/preferences",
  lessonId: "report-preferences-in-depth",
  autoStart: false,
  steps: [
    {
      target: field("name"),
      waitFor: field("name"),
      waitTimeoutMs: 10000,
      title: "How the report refers to you",
      content: "Include Name, Include Badge Number, and Include Rank/Title decide how the draft names you. Leave rank blank and you are Officer.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: field("perspective"),
      waitFor: field("perspective"),
      title: "Voice",
      content: "Narrative Perspective is first or third person. Subject Reference Style decides how people are named after the first mention.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: field("time_format"),
      waitFor: field("time_format"),
      title: "Formats",
      content: "Date Format and Time Format set the style, and Include Topic Headings adds section headings to the draft.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: field("common_spellings"),
      waitFor: field("common_spellings"),
      title: "Common Spellings",
      content: "Type a name or term the transcript keeps getting wrong and press Enter. Each entry is one word. Start with your partners and supervisors.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("preferencesSave"),
      waitFor: sel("preferencesSave"),
      title: "Save Preferences",
      content: "Click Save Preferences when you are done, then regenerate a recent case from the Narrative dropdown to see the effect.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
